import { render, staticRenderFns } from "./MealEditDialog.vue?vue&type=template&id=5cb4b478&scoped=true"
import script from "./MealEditDialog.vue?vue&type=script&lang=js"
export * from "./MealEditDialog.vue?vue&type=script&lang=js"
import style0 from "./MealEditDialog.vue?vue&type=style&index=0&id=5cb4b478&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb4b478",
  null
  
)

export default component.exports